import { shape, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const selectableItem = shape({
    key: string,
    label: string,
    value: string,
});
export { selectableItem, };
//# sourceMappingURL=selectable-item.js.map